"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  NavMenuBar: true
};
exports.default = exports.NavMenuBar = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _SkipLink = require("../SkipLink/SkipLink");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useFocusManager = require("../utils/useFocusManager");
var _useFocusWithin = require("../utils/_useFocusWithin");
var _useTypeToFocus = require("../utils/useTypeToFocus");
var _navMenuUtils = require("./_navMenuUtils");
var _NavMenuBar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenuBar.css") : void 0);
var _NavMenuBar2 = require("./NavMenuBar.types");
Object.keys(_NavMenuBar2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NavMenuBar2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NavMenuBar2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-nav-menu-bar';
const NavMenuBar = exports.NavMenuBar = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a;
  const {
      ariaLabel,
      children,
      className,
      hoverToOpen,
      skipLink,
      listProps,
      orientation = 'horizontal'
    } = props,
    navProps = __rest(props, ["ariaLabel", "children", "className", "hoverToOpen", "skipLink", "listProps", "orientation"]);
  const classnames = _bind.default.bind(_NavMenuBar.default);
  const navMenuBarRef = (0, _react.useRef)(null);
  const mergedRef = (0, _reactMergeRefs.default)([navMenuBarRef, ref]);
  const {
    isFocused
  } = (0, _useFocusWithin.useFocusWithin)({
    targetElement: navMenuBarRef.current
  });
  // this is needed to support left and right
  // keydown behavior for Submenu as per
  // https://www.w3.org/WAI/ARIA/apg/patterns/menubar/examples/menubar-navigation/#kbd_label
  const {
    moveFocusAndOpenNew
  } = (0, _navMenuUtils.useArrowBasedFocusTraversal)();
  const passChildProps = (child, childProps) => {
    if (child.displayName === 'NavMenu') {
      return {
        hoverToOpen,
        inNavMenuBar: true,
        className: classnames(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${CSS_BLOCK}__list-item`, {
          [`${CSS_BLOCK}--disabled`]: childProps === null || childProps === void 0 ? void 0 : childProps.disabled
        }),
        moveFocusAndOpenNew: orientation === 'horizontal' ? moveFocusAndOpenNew : undefined
      };
    }
    if (child.displayName === 'NavMenuItem') {
      return {
        hoverToOpen,
        className: classnames(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${CSS_BLOCK}__list-item`, {
          [`${CSS_BLOCK}--disabled`]: childProps === null || childProps === void 0 ? void 0 : childProps.disabled
        })
      };
    }
    return {};
  };
  const internalListRef = (0, _react.useRef)(null);
  (0, _useFocusManager.useFocusManager)({
    nextKeyCode: orientation === 'horizontal' ? _keycode.default.codes.right : _keycode.default.codes.down,
    previousKeyCode: orientation === 'horizontal' ? _keycode.default.codes.left : _keycode.default.codes.up,
    firstFocusIndex: 0,
    suppressInitialAttachment: true,
    stopKeyPressPropagation: true,
    useHomeAndEndKeys: true,
    onlyContainedEvents: true
  }, !!isFocused, internalListRef);
  const {
    handleTypeToFocus
  } = (0, _useTypeToFocus.useTypeToFocus)({
    focusCandidates: Array.from(((_a = internalListRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role="menuitem"]')) || []),
    keyStrokeTimeout: 50,
    focusMatchingItem: _navMenuUtils.focusMatchingItem
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (skipLink === null || skipLink === void 0 ? void 0 : skipLink.url) && (skipLink === null || skipLink === void 0 ? void 0 : skipLink.label) ? /*#__PURE__*/_react.default.createElement(_SkipLink.SkipLink, Object.assign({}, skipLink)) : null, /*#__PURE__*/_react.default.createElement("nav", Object.assign({}, navProps, {
    "aria-label": ariaLabel,
    ref: mergedRef,
    className: classnames(className, CSS_BLOCK)
  }), /*#__PURE__*/_react.default.createElement("ul", Object.assign({}, listProps, {
    "aria-label": ariaLabel,
    className: classnames(`${CSS_BLOCK}__list`, listProps === null || listProps === void 0 ? void 0 : listProps.className),
    role: "menubar",
    "aria-orientation": orientation === 'vertical' ? 'vertical' : undefined,
    onKeyDown: (0, _chainFunction.default)(handleTypeToFocus, listProps === null || listProps === void 0 ? void 0 : listProps.onKeyDown),
    ref: (listProps === null || listProps === void 0 ? void 0 : listProps.ref) ? (0, _reactMergeRefs.default)([listProps.ref, internalListRef]) : internalListRef
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children))));
});
NavMenuBar.displayName = 'NavMenuBar';
var _default = exports.default = NavMenuBar;